import { getRegistrationDeadline, inEarlyAdmissionsRegistrationPeriod } from 'AdmissionOffer';
import { afterRegistrationOpenDate, getStartDate, registrationDeadlineHasPassed, registrationOpenDate } from 'Cohorts';
import { formattedUserFacingMonthDayLong, formattedUserFacingMonthDayYearLong } from 'DateHelpers';
import { type CurrentUser, getAdmissionOffer, getCohort } from 'Users';
import { type CohortDates } from './TuitionAndRegistration.types';

// Every value derives from the cohort and the admission offer, so no watcher is needed.
export function useCohortDates(currentUser: CurrentUser): CohortDates | null {
    const admissionOffer = getAdmissionOffer(currentUser);
    const cohort = getCohort(currentUser);

    if (!admissionOffer || !cohort) return null;

    const registrationDeadline = getRegistrationDeadline(admissionOffer, cohort);
    const startDate = getStartDate(cohort);
    const inEarlyAdmissions = inEarlyAdmissionsRegistrationPeriod(admissionOffer);

    return {
        beforeRegistrationDeadline: !registrationDeadlineHasPassed(cohort) && !afterRegistrationOpenDate(cohort),
        classStartDate: formattedUserFacingMonthDayYearLong(startDate, false),
        classStartDateMobile: formattedUserFacingMonthDayLong(startDate, false),
        inEarlyAdmissionsRegistrationPeriod: inEarlyAdmissions,
        registrationDeadline: formattedUserFacingMonthDayYearLong(registrationDeadline),
        registrationDeadlineMobile: formattedUserFacingMonthDayLong(registrationDeadline),
        registrationOpenDate: formattedUserFacingMonthDayYearLong(registrationOpenDate(cohort), false),
        registerEnabled: afterRegistrationOpenDate(cohort) || inEarlyAdmissions,
    };
}
